import type { SourcingEventDto } from "../../../autogen/bff-api";
import { allowsNegotiation } from "../../sourcing-events/buyer/wizard/utils/procedure";
import { allowsPartIIDialogue } from "./partIIDialogue";

/**
 * Mirrors NegotiationRoundV2Service.roundsAllowed in the BFF. Private competitions may always
 * negotiate. A public one may where the procedure allows it (FOA § 23-6), once the § 23-2
 * invitation settles the participants, or as a Part II dialogue (FOA § 9-3) once the bid deadline
 * has passed and the tenderers are known.
 */
export const supportsNegotiationRounds = (event: SourcingEventDto, now: number = Date.now()): boolean => {
  if (event.eventContext.type === "Private") return true;
  if (event.eventContext.type !== "Public") return false;
  if (allowsPartIIDialogue(event)) {
    const deadline = event.eventData.bidSubmissionDeadline;
    return deadline != null && Date.parse(deadline) <= now;
  }
  if (!allowsNegotiation(event.eventContext.procedureType)) return false;
  return event.eventContext.qualificationRound?.invitation != null;
};
